module.exports = __webpack_public_path__ + "media/images/pushup3-67845cfa11e6426c2146502d90b0d272.png";